export default {
  fileHelper: {
    /**
     * 将文件数组转成 ';'分割的字符串
     * @date 2021-04-23
     * @param {any} files
     * @returns {any}
     */
    filePathsToStr(files) {
      let str = "";
      files.map(files => {
        if (str == "") {
          str = files;
        } else {
          str += `;${files}`;
        }
      })

      return str;
    },

    /**
     * 将 ';'分割的字符串 转成文件数组
     * @date 2021-04-23
     * @param {any} iamgesStr
     * @returns {any}
     */
    strTofilePaths(iamgesStr) {
      let fileList = new Array();
      let images = iamgesStr
        .split(";");
      if (images != "") {
        for (let i = 0; i < images.length; i++) {
          fileList.push(images[i]);
        }
      }
      return fileList;
    },

    /**
     * 描述
     * @date 2021-04-23
     * @param {String} filtersStr //要处理的filters参数
     * @param {Object} condition//搜索条件
     * @param {Array} formData//搜索项
     * @param {String} keywordsStr//搜索项绑定值为keywords时,使用的预设字符串
     * @returns {String}
     */
    filtersStr(filtersStr, condition, formData, keywordsStr) {
      if (condition) {
        formData.map(item => {
          if (item.type == 'select') {
            if (condition[item.model] !== "999") {
              filtersStr += `${item.model}==${condition[item.model]},`;
            }
          } else if (item.type == 'dateTime') {
            if (condition[item.model]) {
              filtersStr += `${item.model}>=${condition[item.model][0]},`;
              filtersStr += `${item.model}<=${condition[item.model][1]},`;
            }
          } else {
            if (condition[item.model]) {
              if (item.model == 'keywords') {
                filtersStr += `${keywordsStr}${condition.keywords},`;
              } else {
                filtersStr += `${item.model}==${condition[item.model]},`;
              }
            }
          }
        })
      }

      return filtersStr
    },

    /**
     * 描述 对json数组中的参数进行处理 0转为null或null转为0
     * @date 2021-06-22
     * @param {any} utils 参数数组
     * @param {any} results 结果数组
     * @param {any} type 0是0转null 1是null转0
     * @returns {any}
     */
    initData(utils, results, type) {
      utils.map((item) => {
        if (type == 0) {
          if (results[item] == 0) {
            results[item] = null;
          }
        } else {
          if (!results[item]) {
            results[item] = 0;
          }
        }
      });
      return results
    },

    getWeekStart(dd, sort) {
      var week = dd.getDay(); //获取时间的星期数
      var minus = week ? week - 1 : 6;
      var maxus = week ? 7 - week : week;
      if (sort) {
        dd.setDate(dd.getDate() - minus); //获取minus天前的日期
      } else {
        dd.setDate(dd.getDate() + maxus); //获取minus天前的日期
      }
      return dd.Format("yyyy-MM-dd");
    },

    /**
     * json数组去重
     * @date 2021-12-27
     * @param {any} array
     * @param {any} key
     * @returns {any}
     */
    uniqueArray(array, key) {
      var result = [array[0]];
      array.map(item=>{
        var repeat = false;
        for (var j = 0; j < result.length; j++) {
          if (item[key] == result[j][key]) {
            repeat = true;
            break;
          }
        }
        if (!repeat) {
          result.push(item);
        }
      })
      return result;
    },

  }
}